'use strict'
import axios from 'axios'
// 注册axios
const http = axios.create({
  baseURL: process.env.VUE_APP_BASEURL,
  timeout: 3000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
})
// TODO 请求拦截
http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) config.headers['Authorization'] = token
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
// TODO 响应拦截
http.interceptors.response.use(
  (response) => {
    const { data } = response
    console.log(data)
    if (data.errCode == 'USER50001') {
      localStorage.removeItem("token");
      window.location.reload();
    }
    return data
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default http
